import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ClerkProvider } from "@clerk/clerk-react";
import App from "./App.jsx";
import SubmitPage from "./pages/Submit.jsx";
import RewardPage from "./pages/Reward.jsx";
import AdminPage from "./pages/Admin.jsx";
import AdminLogin from "./pages/AdminLogin.jsx";
import "./styles/index.css";

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

const RouterTree = (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/submit" element={<SubmitPage />} />
      <Route path="/thanks" element={<RewardPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/sign-in/*" element={<AdminLogin />} />
    </Routes>
  </BrowserRouter>
);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    {PUBLISHABLE_KEY ? (
      <ClerkProvider
        publishableKey={PUBLISHABLE_KEY}
        signInForceRedirectUrl="/admin"
        signInFallbackRedirectUrl="/admin"
        appearance={{
          variables: {
            colorPrimary: "#f44800",
            colorBackground: "#0a0f1c",
            colorText: "#ffffff",
            colorTextSecondary: "rgba(255,255,255,0.6)",
            colorInputBackground: "rgba(255,255,255,0.05)",
            colorInputText: "#ffffff",
            borderRadius: "0.625rem",
          },
        }}
      >
        {RouterTree}
      </ClerkProvider>
    ) : (
      RouterTree
    )}
  </React.StrictMode>
);
